import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="hexis-footer"
      className="font-mono"
      style={{
        borderTop: "1px solid rgba(197,160,89,0.18)",
        padding: "36px 6vw 48px",
        display: "flex",
        flexWrap: "wrap",
        gap: 24,
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 11,
        letterSpacing: "0.2em",
        textTransform: "uppercase",
        color: "var(--parchment-dim)",
        marginTop: 80,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ color: "var(--brass)" }}>✦</span>
        <span>HEXIS OS · Meta-Architect</span>
        <span style={{ color: "var(--muted)" }}>· {new Date().getFullYear()}</span>
      </div>
      <div style={{ display: "flex", gap: 28, flexWrap: "wrap" }}>
        <Link
          to="/leaderboard"
          data-testid="footer-leaderboard-link"
          style={{ color: "var(--parchment-dim)", textDecoration: "none" }}
        >
          Leaderboard
        </Link>
        <Link
          to="/terms"
          data-testid="footer-terms-link"
          style={{ color: "var(--parchment-dim)", textDecoration: "none" }}
        >
          Terms
        </Link>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          style={{ color: "var(--parchment-dim)", textDecoration: "none" }}
        >
          Privacy
        </Link>
        <a
          href="mailto:hello@hexis.os"
          data-testid="footer-contact-link"
          style={{ color: "var(--parchment-dim)", textDecoration: "none" }}
        >
          Contact
        </a>
      </div>
    </footer>
  );
}
